import { LocalStorageKeys } from '@/app'
import { ProgressBarProps } from '@/components'
import { maybeOpenRegistrationWall } from '@/features/Auth/session/registrationWall'
import { isLoggedIn } from '@/features/Auth/session/utils'
import { analytics } from '@/services/analytics/segment'
import { Hurdle, Module } from '@/types'
import { globalState } from '@codeleap/store'
import { format, isValid } from 'date-fns'
import { navigate } from 'gatsby'

// @ts-expect-error
import hurdle from '../app/assets/images/hurdle.png'

const freeHurdleStore = globalState({ alreadyPlayedHurdle: false }, { persistKey: LocalStorageKeys.HURDLE_FREE_PLAYED })

export function setFreeHurdlePlayed(to: boolean) {
  freeHurdleStore.set({ alreadyPlayedHurdle: to })
}

export const canPlayHurdle = () => {
  if (isLoggedIn()) return true

  const alreadyPlayed = freeHurdleStore.get().alreadyPlayedHurdle

  return !alreadyPlayed
}

export function navigateToHurdle() {
  if (!canPlayHurdle()) {
    maybeOpenRegistrationWall()
    return
  }

  analytics.track('hurdle_start')

  navigate('/hurdle/game/' as never)
}

export function getHurdleCompletion(hurdle: Hurdle) {
  if (!hurdle || hurdle?.guesses?.length === 0) return 0
  if (hurdle.completed) return 100
  return 50
}

export function getHurdleProgressProps(hurdle: Hurdle): ProgressBarProps {
  const currentProgress = getHurdleCompletion(hurdle)
  return {
    progress: currentProgress,
    text: `${Math.floor(currentProgress / 100)}/1`
  }
}

export const formatHurdleDate = (date?: Date | string | null, showYear = false) => {
  if (!date) return ''

  if (typeof date === 'string') {
    if (date.includes('T')) {
      date = date.split('T')?.[0] // Remove time info
    }
    const [year, month, day] = date.split('-')
    date = new Date(Number(year), Number(month) - 1, Number(day))
  }

  if (!isValid(date)) return ''

  const formatString = showYear ? 'MMM dd, yyyy' : 'MMM dd'

  return format(date, formatString)
}

export const hurdleItem: Partial<Module> = {
  done: false,
  created_datetime: String(new Date()),
  id: Math.round(Math.random() * 1000),
  title: 'Hurdle',
  description: 'Description',
  is_placeholder: false,
  is_free: false,
  available: true,
  image: hurdle,
  web_image: hurdle,
  mobile_image: hurdle,
  type: 'game',
  url: null,
  flag: 'hurdle'
}
